module.exports = __webpack_public_path__ + "media/images/reportimages/report-e7880739954987212c47370bfd55e526.png";